/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListTrmOrgResponse as AgentApiContractListTrmOrgResponse } from '../../models/AgentApi/Contract/list-trm-org-response';

export interface ApiAgentListTrmOrgGet$Params {

/**
 * ui language code
 */
  lang?: string;

/**
 * flag for printed tickets (1 - only printed else - any)
 */
  ptFlag?: number;
}

export function apiAgentListTrmOrgGet(http: HttpClient, rootUrl: string, params?: ApiAgentListTrmOrgGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListTrmOrgGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('ptFlag', params.ptFlag, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListTrmOrgResponse>>;
    })
  );
}

apiAgentListTrmOrgGet.PATH = '/api/Agent/ListTrmOrg';
